import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import logger from "@insite/client-framework/Logger";
import buildAddToCartTracking from "@MasterBluePrint/Tracking/AddToCart/addToCartTrackingBuilder";
import { getCurrentUrl, getDataLayer } from "@MasterBluePrint/Tracking/trackingHelper";

const addToCartTracking = (product: CartLineModel, productInfo: ProductInfo, state: ApplicationState) => {
    try {
        const currentUrl = getCurrentUrl();
        const payload = buildAddToCartTracking(product, productInfo, state, currentUrl);

        const dataLayer = getDataLayer();
        dataLayer.push({ ecommerce: null });
        dataLayer.push(payload);
    } catch (error) {
        // eslint-disable-next-line no-console
        logger.debug(error);
    }
}

export default addToCartTracking;